import { apiUrl } from '../constants/global';
import { getLoggedUser } from '../state/user';

const user = getLoggedUser();

async function getMgmtCounts(q) {
  return fetch(`${apiUrl}mgmt_counts${q}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function getManagementDashboard(q) {
  return fetch(`${apiUrl}m-dashboard${q}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}
async function getDashboardSummary(q) {
  const query = new URLSearchParams(q).toString();
  return fetch(`${apiUrl}m-dashboard-summary?${query}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function getAuctionOverview(q) {
  const query = new URLSearchParams(q).toString();
  return fetch(`${apiUrl}v2/management/auctions/overview?${query}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function getMgmtTodays() {
  return fetch(apiUrl + 'mgmt_todays', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function getMgmtWinners(type) {
  return fetch(`${apiUrl}mgmt_winners?type=${type}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function getMgmtRunning(q = '') {
  return fetch(apiUrl + `mgmt_running?${q}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function getMgmtApprovals() {
  return fetch(apiUrl + 'mgmt_approvals', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

export {
  getMgmtCounts,
  getMgmtTodays,
  getMgmtWinners,
  getMgmtRunning,
  getMgmtApprovals,
  getManagementDashboard,
  getDashboardSummary,
  getAuctionOverview,
};
